import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {JobCategory} from './job-category.model'

@Injectable()
export class JobCategorySelectService {
  list: Observable<JobCategory[]> = <Observable<JobCategory[]>>this.http.get(
    '/api/job-categories'
  ).pipe(
    map((response: any) => response.results),
    shareReplay()
  );

  constructor(private http: HttpClient) {
  }
}
